export default function getQueryStringForPageIdentifiers(ids) {
    const queryParams = [];
    const { pageGroup, pageType, familyId, customerId, instanceId, platformId } = ids;
    if (pageGroup) {
        queryParams.push(`page_group=${pageGroup}`);
    }
    queryParams.push(`page=${pageType}`);
    if (familyId) {
        queryParams.push(`family_id=${familyId}`);
    }

    if (customerId) {
        queryParams.push(`customer_id=${customerId}`);
    }
    if (instanceId) {
        queryParams.push(`instance_id=${instanceId}`);
    }
    if (platformId) {
        queryParams.push(`platform_id=${platformId}`);
    }

    return queryParams.length ? `?${queryParams.join('&')}` : '';
}
